import React from 'react';
import { Panel, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import ui from '../../common/services/ui';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-regular-svg-icons';

const List = ({ isReadonly, t, ...rest }) => {
	const columns = [
		{
			header: t('Voucher_Code'),
			accessor: 'code',
			sortable: true
		},
		{
			header: t('Voucher_BoughtBy'),
			accessor: 'boughtBy',
			sortable: true
		},
		{
			header: t('Voucher_UsedBy'),
			accessor: 'usedBy',
			sortable: true
		},
		{
			header: t('Voucher_Amount'),
			accessor: 'amount',
			sortable: true
		},
		{
			header: t('Voucher_Balance'),
			accessor: 'balance',
			sortable: true
		},
		{
			header: t('Voucher_Status'),
			accessor: 'status.name',
			sortable: true
		},
		{
			header: t('Voucher_Created'),
			accessor: 'created',
			sortable: true,
			cell: (created) => (ui.formatDateTime(created))
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id, row) => (<div>
				<Link to={`/vouchers/${id}`} className='btn btn-teal'><FontAwesomeIcon icon={faEdit} /> {t('Common_Edit')}</Link>
			</div>)
		}
	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);